import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {environment} from './environments/environment';
import {AiStudioModule} from "apps/aiStudio/ai-studio.module";

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AiStudioModule)
     .catch(err => console.error(err));
